import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import { useState } from 'react';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UICheckbox from 'UIComponents/input/UICheckbox';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { OLAF, THUNDERDOME } from 'HubStyleTokens/colors';
import UIList from 'UIComponents/list/UIList';
import UIIllustration from 'UIComponents/image/UIIllustration';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { KB_ONBOARDING_PATH } from '../../routing/constants/RouteConstants';
import { createTracker } from 'usage-tracker';
import events from '../../../events.yaml';
import UIBadge from 'UIComponents/badge/UIBadge';
import { getIsSuperAdmin } from '../../selectors/scopes';
import { useAppSelector } from '../../utils/hooks';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledList = styled(UIList).withConfig({
  displayName: "KBv3EnrollmentModal__StyledList",
  componentId: "mtmcep-0"
})([".font-500{font-weight:500;}"]);
const KBv3EnrollmentModal = () => {
  const history = useHistory();
  const [isTermsAcknowledged, setIsTermsAcknowledged] = useState(false);
  const usageTracker = createTracker({
    events
  });
  const handleConfirm = () => {
    usageTracker.track('kbBetaOptIn', {
      screen: 'app'
    });
    history.push(`${KB_ONBOARDING_PATH}?cancel=back`);
  };
  const handleReject = () => {
    usageTracker.track('kbBetaOptOut', {
      screen: 'app'
    });
    history.push('/');
  };
  const isSuperAdmin = useAppSelector(getIsSuperAdmin);
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 850,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      className: "text-left p-bottom-4",
      children: /*#__PURE__*/_jsxs("h2", {
        style: {
          verticalAlign: 'middle'
        },
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3OptInModal.title"
        }), /*#__PURE__*/_jsx(UIBadge, {
          use: "beta",
          className: "m-left-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.v3OptInModal.betaLabel"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "text-left",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.v3OptInModal.description"
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-row align-start justify-around p-y-6",
        children: [/*#__PURE__*/_jsxs(StyledList, {
          style: {
            maxWidth: 450
          },
          className: "p-left-4",
          childClassName: "m-bottom-3 font-500",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-row",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(UIIconCircle, {
                name: "next",
                backgroundColor: THUNDERDOME,
                color: OLAF,
                size: 10,
                className: "m-right-2 p-all-1"
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.v3OptInModal.bulletPoints.wysiwgEdit"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-row",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(UIIconCircle, {
                name: "next",
                backgroundColor: THUNDERDOME,
                color: OLAF,
                size: 10,
                className: "m-right-2 p-all-1"
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.v3OptInModal.bulletPoints.styleControls"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-row",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(UIIconCircle, {
                name: "next",
                backgroundColor: THUNDERDOME,
                color: OLAF,
                size: 10,
                className: "m-right-2 p-all-1"
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.v3OptInModal.bulletPoints.languageTranslations"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-row",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(UIIconCircle, {
                name: "next",
                backgroundColor: THUNDERDOME,
                color: OLAF,
                size: 10,
                className: "m-right-2 p-all-1"
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.v3OptInModal.bulletPoints.customHeaderAndFooterHTML"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-row",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(UIIconCircle, {
                name: "next",
                backgroundColor: THUNDERDOME,
                color: OLAF,
                size: 10,
                className: "m-right-2 p-all-1"
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.v3OptInModal.bulletPoints.navigationDesigns"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex-row",
            children: [/*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(UIIconCircle, {
                name: "next",
                backgroundColor: THUNDERDOME,
                color: OLAF,
                size: 10,
                className: "m-right-2 p-all-1"
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.v3OptInModal.bulletPoints.cloneArticles"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(UIIllustration, {
          className: "p-all-2",
          name: "knowledge-base"
        })]
      }), /*#__PURE__*/_jsx(UITooltip, {
        placement: "left",
        disabled: isSuperAdmin,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3OptInModal.contactSuperAdminOptin"
        }),
        children: /*#__PURE__*/_jsx(UICheckbox, {
          checked: isTermsAcknowledged,
          readOnly: !isSuperAdmin,
          onChange: ({
            target: {
              checked
            }
          }) => {
            setIsTermsAcknowledged(checked);
          },
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "knowledgeContentUI.v3OptInModal.betaTermsCheckboxLabel_jsx",
            elements: {
              UILink
            },
            options: {
              href: 'https://legal.hubspot.com/hubspot-beta-terms',
              external: true
            }
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-5",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.v3OptInModal.contactSupport_jsx",
          elements: {
            UILink
          },
          options: {
            href: 'https://help.hubspot.com/',
            external: true
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      align: "right",
      children: [/*#__PURE__*/_jsx(UIButton, {
        onClick: handleReject,
        "data-test-id": "request-beta-modal-cancel-btn",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3OptInModal.noThanksButton"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "request-beta-modal-accept-btn",
        disabled: !isTermsAcknowledged,
        onClick: handleConfirm,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3OptInModal.continueButton"
        })
      })]
    })]
  });
};
export default KBv3EnrollmentModal;